









































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrBiduiPreviewYanse extends Vue {
  @Prop()
  private message: any;
}
